import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.function.name";
import "core-js/modules/es7.promise.finally";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import ApiService from '../../../services/apiService';
import { gatewayMgmtMixin } from '../../../utils/vuex';
import { themesMixin } from '../../../utils/themes';
import map from 'lodash/map';
import get from 'lodash/get';
import moment from 'moment';
export default {
  name: 'NiotaClassicGwMgmtVisualization',
  mixins: [gatewayMgmtMixin, themesMixin],
  props: {
    accountId: {
      type: Number,
      required: true
    },
    filterWarning: {
      type: Boolean,
      required: false,
      default: false
    },
    filterAlert: {
      type: Boolean,
      required: false,
      default: false
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      packetsBar: {},
      rssiGraph: {},
      lsnrGraph: {},
      sfGraph: {},
      loadingMetrics: false,
      graphData: false,
      range: '24h',
      interval: 'hour',
      selectedTimeFrame: {
        value: '24h',
        interval: 'hour',
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      },
      timeFrameName: this.$i18n_t('NiotaClassic.Devices.details.last24'),
      intervalId: null
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions', 'refreshGMMinutes'])), {}, {
    formCardButtons: function formCardButtons() {
      return [{
        icon: 'fal fa-times',
        color: 'danger',
        action: 'close',
        tooltip: this.$i18n_t('Common.cancel')
      }];
    },
    timeFrames: function timeFrames() {
      return [{
        value: '24h',
        interval: 'hour',
        name: this.$i18n_t('NiotaClassic.Devices.details.last24')
      }, {
        value: '1w',
        interval: 'day',
        name: this.$i18n_t('NiotaClassic.Devices.details.lastWeek')
      }, {
        value: '1M',
        interval: 'day',
        name: this.$i18n_t('NiotaClassic.Devices.details.lastMonth')
      }];
    }
  }),
  watch: {
    refreshGMMinutes: function refreshGMMinutes(newValue) {
      var _this = this;

      if (this.isFetching) {
        return;
      }

      this.clearGMInterval(this.intervalId);

      if (newValue > 0) {
        var seconds = this.convertMinutesToSeconds(newValue);
        this.intervalId = setInterval(function () {
          _this.loadAllMetrics();
        }, seconds * 1000);
      }
    },
    isOpen: function isOpen() {
      if (this.isOpen) {
        this.initData();
      } else {
        this.range = '24h';
        this.interval = 'hour';
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.clearGMInterval(this.intervalId);
  },
  methods: {
    initData: function initData() {
      this.loadAllMetrics();
    },
    loadAllMetrics: function loadAllMetrics() {
      var _this2 = this;

      if (!this.isOpen) {
        return;
      }

      this.loadingMetrics = true;
      var requestData = {
        accountId: this.accountId,
        range: this.range,
        interval: this.interval,
        options: JSON.stringify([this.filterWarning ? 'warning' : null, this.filterAlert ? 'alert' : null].filter(function (o) {
          return o;
        }))
      };
      ApiService.gwMgmtLoadAllGatewayMetrics(requestData).then(function (gateways) {
        if (gateways.length) {
          _this2.setMetricsData(gateways);
        }
      }).catch(function (error) {
        _this2.$snack(_this2.$i18n_t('NiotaClassic.GWMonitoring.snacks.loadMetricsFailed'), 'error');

        console.error(error);
      }).finally(function () {
        _this2.loadingMetrics = false;
      });
    },
    selectTimeFrame: function selectTimeFrame(time) {
      this.range = time.value;
      this.interval = time.interval;
      this.timeFrameName = time.name;
      this.loadAllMetrics();
    },
    mapLabelsToLocalTime: function mapLabelsToLocalTime(labels) {
      return (labels || []).map(function (date) {
        return moment(new Date(date)).format('LT');
      });
    },
    setMetricsData: function setMetricsData(gateways) {
      var _this3 = this;

      var labels = null; // find the first gateway that has correct labels (i.e. has RSSI/LSNR/SF data)
      // all the other gateways have the same time-labels, so only need to find 1 valid set

      var i = 0;

      while (i < gateways.length) {
        labels = get(gateways, "[".concat(i, "].rssiLsnrSfMetrics.data.rssi.labels"));

        if (labels && labels.length > 0) {
          break;
        }

        i++;
      }

      var packetMetricsData = {
        labels: [],
        data: []
      };
      var rssiMetricsData = {
        labels: this.mapLabelsToLocalTime(labels),
        metrics: []
      };
      var lsnrMetricsData = {
        labels: this.mapLabelsToLocalTime(labels),
        metrics: []
      };
      var sfMetricsData = {
        labels: this.mapLabelsToLocalTime(labels),
        metrics: []
      };
      var gatewayColours = [];
      map(gateways, function (gateway) {
        gatewayColours.push(_this3.rgbToHex(_this3.randomColor()));
        var countPackets = get(gateway, 'countPackets', 0);
        var rssiMetrics = get(gateway, 'rssiLsnrSfMetrics.data.rssi.data', []);
        var lsnrMetrics = get(gateway, 'rssiLsnrSfMetrics.data.lsnr.data', []);
        var sfMetrics = get(gateway, 'rssiLsnrSfMetrics.data.sf.data', []);

        if (countPackets > 0) {
          packetMetricsData.data.push(countPackets);
          packetMetricsData.labels.push(gateway.title);
        }

        if (rssiMetrics.length) {
          rssiMetricsData.metrics.push({
            data: rssiMetrics,
            label: gateway.title
          });
        }

        if (lsnrMetrics.length) {
          lsnrMetricsData.metrics.push({
            data: lsnrMetrics,
            label: gateway.title
          });
        }

        if (sfMetrics.length) {
          sfMetricsData.metrics.push({
            data: sfMetrics,
            label: gateway.title
          });
        }
      });

      if (packetMetricsData.data.length) {
        this.packetsBar = this.updateBar(packetMetricsData);
        this.rssiGraph = this.updateGraph(rssiMetricsData, gatewayColours);
        this.lsnrGraph = this.updateGraph(lsnrMetricsData, gatewayColours);
        this.sfGraph = this.updateGraph(sfMetricsData, gatewayColours);
        this.graphData = true;
      } else {
        this.graphData = false;
        this.$snack(this.$i18n_t('NiotaClassic.GWMonitoring.snacks.notFound'), 'info');
      }
    },
    updateBar: function updateBar(data) {
      var graphData = {
        common: {
          color: this.vuetifyColorHex(),
          labels: data.labels
        },
        individual: []
      };
      graphData.individual.push({
        data: data.data,
        label: "".concat(this.$i18n_t('NiotaClassic.GWMonitoring.form.sumPackets'), " (").concat(this.timeFrameName, ")")
      });
      return graphData;
    },
    updateGraph: function updateGraph(data, colours) {
      var graphData = {
        common: {
          labels: data.labels
        },
        individual: []
      };
      data.metrics.forEach(function (metric, i) {
        graphData.individual.push({
          data: metric.data,
          label: metric.label,
          color: colours[i]
        });
      });
      return graphData;
    }
  }
};